import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";

export const Loading = () => {
    return (
        <div className="Track d-flex flex-column flex-grow-1 h-100">
            <div className="container">
                <div className="text-center h-100">
                    <FontAwesomeIcon
                        icon={faCircleNotch}
                        size="6x"
                        color="white"
                        spin
                        style={{ verticalAlign: "middle", marginTop: "150px" }}
                    />
                </div>
            </div>
        </div>
    );
};
